import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { TfModulesData} from "./tfmodules.model";
import { map } from "rxjs";
import { IacRepositoryTypeEnum } from "src/app/shared/enum/iac-repository-type.enum";
import { IacRepositories } from "src/app/store/iac/repository/gitlab/iac-repositories.model";

@Injectable({
    providedIn: 'root'
})
export class TfModulesService {

    constructor(private httpClient: HttpClient, private configService: ConfigService){

    }

    loadTfModulesData(){
        return this.httpClient.get<TfModulesData>(`${this.configService.config.apiUrl}/iac/factorisations`)
        .pipe(
            map((response=>{
                const data = []
                const repositoryEnumKeys = Object.keys(IacRepositoryTypeEnum);
                for(let type in response){
                    const repositories = response[type as keyof IacRepositories]
                    if(repositoryEnumKeys.includes(type)){
                        data.push(...repositories.checked.map((value) => {return {...value, type: type}}))
                        data.push(...repositories.unchecked.map((value) => {return {...value, type: type}}))
                        data.push(...repositories.ignored.map((value) => {return {...value, type: type}}))
                    }
                }
                return data
            }))
        )
    }
}
